import GclidFlag from 'utils/gclid_flag'

class SaveGclidFlag {
  static async init () {
    return GclidFlag.save()
  }
}

export default SaveGclidFlag
